module.exports = __webpack_public_path__ + "img/portugal-congenital-and-perinatal-diseases-female.75b324d7.png";